import React, { useState, useRef, useEffect } from "react";
import "./AdvertiserRegister.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";
import Select from "react-select";
import { toast } from "react-toastify";
import { Button, Flex, Modal } from "antd";
import Meta from "../../components/Meta";
function AdvertiserRegister() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [agree, setAgree] = useState(false);
  const verifyRef = useRef(null);
  const registerRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [zipcode, setCode] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailForVerify, setEmailForVerify] = useState("");
  const [otp, setOtp] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [file, setFile] = useState(null);

  const [singInHeading, setHeading] = useState("Sign In as a Service Provider");
  const advertiserId = localStorage.getItem("advertiserId");

  const token = localStorage.getItem("token");

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState("");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
  };
  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#252525",
      borderColor: state.isFocused ? "#252525" : "#252525",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#252525",
      },
      "&:focus": {
        borderColor: "#252525",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#252525"
          : "#252525",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#252525",
      border: "1px solid #252525",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };
  useEffect(() => {
    if (token) {
      if (advertiserId) {
        navigate("/advertiser-auth/profile");
      }
    }
  }, [token]);
  const handleChangeTab = () => {
    switch (activeTab) {
      case "register":
        return setActiveTab("login");
      case "login":
        return setActiveTab("register");
      default:
        return setActiveTab("register");
    }
  };
  useEffect(() => {
    const getOptions = async (company) => {
      const data = {
        titleCompany: company
      }
      try {
        const response = await fetch(`${API}/auth/role-check/get-allZipCodes-advertisers`,{
          method: "POST",
          body: JSON.stringify(data),
          headers: { "Content-Type": "application/json" }, // Fix: Add headers
        });
        const json = await response.json();

        if (response.ok) {
          const aqdas = await json.zipcodes.map((data) => ({
            label: data,
            value: data,
          }));
          if (aqdas) {
            setOptions(aqdas);
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    if(selectedOption.length > 1){
      setCode("")
      getOptions(selectedOption);
    }else{
      setOptions([])
    }

 
  }, [selectedOption]);

  useEffect(() => {
    if (activeTab === "register") {
      if (verifyRef) {
        verifyRef.current.style.display = "none";
      }
    }
  }, [activeTab]);

  function loginValidation() {
    if (emailLogin.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (passwordLogin.length < 1) {
      toast.error("Password is required");
      return false;
    }

    return true;
  }
  function otpValidation() {
    if (otp.length < 1) {
      toast.error("OTP is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  function validation() {
    if (name.length < 1) {
      toast.error("Name is required");
      return false;
    }

    if (email.length < 1) {
      toast.error("Email is required");
      return false;
    } else {
      if (!isValidEmail(email)) {
        toast.error("Please enter valid email");
        return false;
      }
    }
 
    if (selectedOption.length < 1) {
      toast.error("Company Type is required");
      return false;
    }
    if (zipcode.length < 5) {
      toast.error("Zip Code is required/Invalid");
      return false;
    }
    if (phonenumber.length < 1) {
      toast.error("Phone number required");
      return false;
    }
    if (phonenumber.length > 10) {
      toast.error("Phone length should be under 11");
      return false;
    }
    if (password.length < 1) {
      toast.error("Password is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }
    return true;
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    const validate = await validation();

    if (validate) {
      const formData = new FormData();

      formData.append("fulName", name);
      formData.append("email", email);
      formData.append("phoneNumber", phonenumber);
      formData.append("password", password);
      formData.append("zipCode", parseInt(zipcode, 10));
      formData.append("titleCompany", selectedOption);
      formData.append("file", file);
      setLoading(true);
      const toastLoading = await toast.loading("Creating new agent...");
      try {
        const response = await fetch(`${API}/advertiser/register-advertiser`, {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Please check your email to verify your account");
          setLoading(false);
          // setEmailForVerify(json.data.email);

          // if (registerRef) {
          //   registerRef.current.style.display = "none";
          // }
          // if (verifyRef) {
          //   verifyRef.current.style.display = "block";
          // }
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          handleChangeTab();

          // navigate("/before-begin", { state: { email: json.data.email } });
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        // toast.error(error.message);
        toast.error("Network error, try again!");
      } finally {
        setLoading(false);
        toast.dismiss(toastLoading);
      }
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();

    const validate = await otpValidation();

    if (validate) {
      const data = {
        email: emailForVerify,
        otp: parseInt(otp, 10),
      };
      try {
        setLoading(true);
        const toastLoading = await toast.loading("OTP verifying...");
        const response = await fetch(
          `${API}/advertiser/advertiser-verify-otp`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          // toast.success("Advertiser verified successfully");
          setLoading(false);
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          // handleChangeTab();

          navigate("/before-begin", { state: { email: emailForVerify } });
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        // toast.error(error.message);
        toast.error("Network error, try again!");
      } finally {
        setLoading(false);
      }
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    const validate = await loginValidation();

    if (validate) {
      const data = {
        email: emailLogin,
        password: passwordLogin,
      };
      try {
        setLoading(true);
        const toastLoading = toast.loading("Signing in...");
        const response = await fetch(`${API}/advertiser/login-advertiser`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Signed in successfully");
          setLoading(false);
          await localStorage.removeItem("token");
          await localStorage.removeItem("laId");
          await localStorage.removeItem("laEmail");
          await localStorage.removeItem("laName");
          await localStorage.removeItem("laPhone");
          await localStorage.removeItem("laState");
          await localStorage.removeItem("token");
          await localStorage.removeItem("agentId");
          await localStorage.removeItem("agentEmail");
          await localStorage.removeItem("agentName");
          await localStorage.removeItem("agentPhone");

          await localStorage.removeItem("agentVendorType");
          await localStorage.removeItem("agentState");
          await localStorage.removeItem("agentZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("userId");
          await localStorage.removeItem("userEmail");
          await localStorage.removeItem("userName");
          await localStorage.removeItem("userPhone");
          await localStorage.removeItem("userZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("advertiserId");
          await localStorage.removeItem("email");
          await localStorage.removeItem("name");
          await localStorage.removeItem("phone");
          await localStorage.removeItem("zipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("adminId");
          await localStorage.removeItem("adminEmail");
          await localStorage.removeItem("adminName");
          await localStorage.removeItem("adminPhone");
          await localStorage.removeItem("token");
          await localStorage.removeItem("addhypeId");
          await localStorage.removeItem("addhypeEmail");
          await localStorage.removeItem("addhypeName");
          await localStorage.removeItem("addhypePhone");
          localStorage.setItem("token", json.data.token);
          localStorage.setItem("advertiserId", json.data.advertiser._id);
          localStorage.setItem("email", json.data.advertiser.email);
          localStorage.setItem("name", json.data.advertiser.fulName);
          localStorage.setItem("phone", json.data.advertiser.phoneNumber);
          localStorage.setItem("zipCode", json.data.advertiser.zipCode);

          navigate("/advertiser-auth/profile");
          setEmailLogin("");
          setPasswordLogin("");
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
        // toast.error("Network error, try again!");
      } finally {
        setLoading(false);
      }
    }
  };

  const [openResponsive, setOpenResponsive] = useState(false);

  const openTerms = () => {
    setOpenResponsive(true);
  };
  const handleForgot = (e) => {
    e.preventDefault();
    navigate("/forgot-password", { state: { type: "advertiser" } });
  };
   const [isMobile, setIsMobile] = useState(false);
          useEffect(() => {
            const handleResize = () => {
              setIsMobile(window.innerWidth <= 600);
            };
        
            handleResize();
        
            window.addEventListener("resize", handleResize);
            return () => {
              window.removeEventListener("resize", handleResize);
            };
          }, []);
  return (
    <>
      <Meta
        title="Advertise with Deal Direct Homes | Sign Up"
        description="Reach thousands of home buyers by advertising your services on Deal Direct Homes in your zipcodes."
      />
      <div className="agent-register-section">
        <NavbarComponent />
        {activeTab === "register" ? (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <span ref={registerRef} className="w-100">
                  <h2 className="agent-register-heading">
                    Join as a Service Provider
                  </h2>
                  <div className="my-2">
                    <button
                      className="btn agent-login-register-tab"
                      onClick={handleChangeTab}
                    >
                      Sign In
                    </button>
                    <button className="btn agent-login-register-tab ms-3 active-agent-login-register-tab">
                      Register
                    </button>
                  </div>
                  <form className="agent-register-form">
                    <input
                      type="text"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="Full Name"
                      aria-describedby="emailHelp"
                      onChange={(e) => setName(e.target.value)}
                    />

                    <input
                      type="email"
                      className="form-control agent-register-input-field"
                      id="exampleInputPassword1"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                   {isMobile ? (
                      <input
                        type="tel"
                        className="form-control agent-register-input-field"
                        id="userPhone"
                        placeholder="Phone number"
                        value={`+1 ${phonenumber}`} // Display "+1" prefix
                        onChange={(e) => {
                          // Remove "+1" and any extra spaces before saving to state
                          const rawNumber = e.target.value
                            .replace(/^\+1\s*/, "")
                            .slice(0, 10);
                          setPhoneNumber(rawNumber);
                        }}
                      />
                    ) : (
                      <div className="agent-register-phone-number-group">
                        <button disabled className="agent-register-phone-code">
                          +1
                        </button>
                        <input
                          type="number"
                          className="form-control agent-register-phone-field"
                          id="exampleInputPassword1"
                          placeholder="Phone Number"
                          maxLength="10"
                          min="0"
                          max="9999999999"
                          pattern="\d*"
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setPhoneNumber(value);
                            e.target.value = value;
                          }}
                        />
                      </div>
                    )}

                    <input
                      type="password"
                      className={`form-control agent-register-input-field ${isMobile ? "" : "pass-input"}`}
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <hr
                      className="text-white agent-register-devider-1"
                      style={{ opacity: "0.1" }}
                    />
                   
                

                    <div className="adv-custom-dropdown">
                      <div
                        className="dropdown-header"
                        onClick={toggleDropdown}
                        role="button"
                        tabIndex={0}
                      >
                        {selectedOption || "Type of Business"}
                        <img
                          src="/img/faq-icon-2.svg"
                          className="me-0"
                          alt=""
                        />
                      </div>
                      {isDropdownOpen && (
                        <ul className="adv-dropdown-options">
                          <li
                            onClick={() =>
                              handleOptionSelect("Title Companies")
                            }
                          >
                            Title Companies
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Escrow Companies")
                            }
                          >
                            Escrow Companies
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Closing Attorney")
                            }
                          >
                            Closing Attorney
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Home Inspection Companies")
                            }
                          >
                            Home Inspection Companies
                          </li>
                          <li
                            onClick={() => handleOptionSelect("NHD Department")}
                          >
                            NHD Department
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Home Owner Insurance Reps")
                            }
                          >
                            Home Owner Insurance Reps
                          </li>
                          <li
                            onClick={() => handleOptionSelect("Home Warranty")}
                          >
                            Home Warranty
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Pest Control/Termite")
                            }
                          >
                            Pest Control/Termite
                          </li>
                          <li
                            onClick={() => handleOptionSelect("Moving Company")}
                          >
                            Moving Company
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect(
                                "General Contractors (Home Improvement)"
                              )
                            }
                          >
                            General Contractors (Home Improvement)
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Heating and Air Conditioning")
                            }
                          >
                            Heating and Air Conditioning
                          </li>
                          <li onClick={() => handleOptionSelect("Plumbers")}>
                            Plumbers
                          </li>
                          <li onClick={() => handleOptionSelect("Electrician")}>
                            Electrician
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Home Cleaning Services")
                            }
                          >
                            Home Cleaning Services
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Home Security Systems")
                            }
                          >
                            Home Security Systems
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Landscape/Gardening Services")
                            }
                          >
                            Landscape/Gardening Services
                          </li>
                          <li
                            onClick={() =>
                              handleOptionSelect("Pool Maintenance/Cleaning")
                            }
                          >
                            Pool Maintenance/Cleaning
                          </li>
                          <li onClick={() => handleOptionSelect("Locksmith")}>
                            Locksmith
                          </li>
                        </ul>
                      )}
                    </div>
                    <Select
                      // isMulti
                      name="colors"
                      styles={colorStyles}
                      options={options}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Choose Zip Codes..."
                      onChange={(e) => setCode(e ? e.value : "")}
                      value={options.find((data) => data.value === zipcode) || null} 
                    />
                    <div className="mb-3 form-check agent-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid pop-up-terms">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid pop-up-close"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Service Provider Agreement
                                </h2>
                                <p className="agreement-paragraph">
                                  By clicking the agree button, you agree to
                                  the following: This agreement is between Deal
                                  Direct Home LLC, hereinto referred to as DDH,
                                  and the Advertiser/SP, hereinto referred to as
                                  SP. It is preferred that all SP’s maintain all
                                  Licenses required by their respective
                                  profession. Each SP will maintain their DDH
                                  Profile including a valid payment source for
                                  reoccurring debits. AV’s understand there will
                                  only be one SP per category in each zip code.
                                  <ol>
                                    <li className="mt-2">
                                      Each SP will be listed on the DDH web page
                                      associated with the Zip Codes paid.
                                    </li>
                                    <li className="mt-2">
                                      Each SP understands they will be featured
                                      and recommended on the initial Welcome
                                      Email distributed upon every profile
                                      completion in the Zip Codes which they
                                      have selected and paid for.
                                    </li>
                                    <li className="mt-2">
                                      Each SP will be reintroduced and
                                      recommended via email to each DDH client
                                      at the appropriate timeline in the Zip
                                      Codes they have selected and paid for.
                                    </li>
                                    <li className="mt-2">
                                      Cost for each Zip Code in each Category is
                                      subject to change with 30 days’ notice.
                                    </li>
                                    <li className="mt-2">
                                      Each SP will be billed 15 days prior to
                                      the beginning of the calendar month.
                                    </li>
                                    <li className="mt-2">
                                      Nonpayment for any reason not resolved in
                                      3 business days will forfeit that category
                                      and zip code.
                                    </li>
                                    <li className="mt-2">
                                      Zip Codes are on a first come first served
                                      basis.
                                    </li>
                                    <li className="mt-2">
                                      Not all Zip Codes in every State/County
                                      will be available. DDH retains the right
                                      to add or delete any category or zip codes
                                      per it sole discretion.
                                    </li>
                                  </ol>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn agent-register-button">
                        Processing...
                      </span>
                    ) : (
                      <button
                        onClick={handleSignUp}
                        className="btn agent-register-button"
                      >
                        Sign Up
                      </button>
                    )}

                    {/* <img
                    src="/img/user-register-devider.svg"
                    className="img-fluid agent-register-devider"
                    alt=""
                  />
                  <button
                    type="button"
                    className="btn agent-register-google-button"
                  >
                    <img src="/img/google.png" alt="" /> Continue with Google
                  </button> */}
                  </form>
                </span>
                <span ref={verifyRef} className="w-100">
                  <h2 className="agent-register-heading code-veri-heading">
                    Verify Account
                  </h2>

                  <form className="agent-register-form code-veri-input">
                    <input
                      type="number"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="00 00"
                      aria-describedby="emailHelp"
                      onChange={(e) => setOtp(e.target.value)}
                    />

                    <label style={{ opacity: "0.8" }} className="code-label">
                      4 - Digit code has been sent to your phone number and
                      email.{" "}
                      {/* <Link className="text-white">Change Details</Link> */}
                    </label>

                    <label className="code-label" style={{ opacity: "0.7" }}>
                      By using Deal Direct Homes (DDH), you agree to these Terms
                      and conditions. If you do not agree, please refrain from
                      using our services. DDH provides property listings and
                      connects agents with licensed real estate agents but does
                      not directly buy, sell, or broker real estate
                      transactions. While we strive to ensure the accuracy and
                      timeliness of information on our platform, we cannot
                      guarantee its completeness.
                    </label>

                    <div className="mb-3 form-check agent-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid pop-up-terms">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid pop-up-close"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Service Provider Agreement
                                </h2>
                                <p className="agreement-paragraph">
                                  By clicking the agree button, you agree to
                                  the following: This agreement is between Deal
                                  Direct Home LLC, hereinto referred to as DDH,
                                  and the Advertiser/SP, hereinto referred to as
                                  SP. It is preferred that all SP’s maintain all
                                  Licenses required by their respective
                                  profession. Each SP will maintain their DDH
                                  Profile including a valid payment source for
                                  reoccurring debits. AV’s understand there will
                                  only be one SP per category in each zip code.
                                  <ol>
                                    <li className="mt-2">
                                      Each SP will be listed on the DDH web page
                                      associated with the Zip Codes paid.
                                    </li>
                                    <li className="mt-2">
                                      Each SP understands they will be featured
                                      and recommended on the initial Welcome
                                      Email distributed upon every profile
                                      completion in the Zip Codes which they
                                      have selected and paid for.
                                    </li>
                                    <li className="mt-2">
                                      Each SP will be reintroduced and
                                      recommended via email to each DDH client
                                      at the appropriate timeline in the Zip
                                      Codes they have selected and paid for.
                                    </li>
                                    <li className="mt-2">
                                      Cost for each Zip Code in each Category is
                                      subject to change with 30 days’ notice.
                                    </li>
                                    <li className="mt-2">
                                      Each SP will be billed 15 days prior to
                                      the beginning of the calendar month.
                                    </li>
                                    <li className="mt-2">
                                      Nonpayment for any reason not resolved in
                                      3 business days will forfeit that category
                                      and zip code.
                                    </li>
                                    <li className="mt-2">
                                      Zip Codes are on a first come first served
                                      basis.
                                    </li>
                                    <li className="mt-2">
                                      Not all Zip Codes in every State/County
                                      will be available. DDH retains the right
                                      to add or delete any category or zip codes
                                      per it sole discretion.
                                    </li>
                                  </ol>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn veri-button">Verifying...</span>
                    ) : (
                      <button
                        onClick={handleVerify}
                        className="btn veri-button"
                      >
                        Verify
                      </button>
                    )}
                  </form>
                </span>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="advertiser-register-image-conatiner"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <h2 className="agent-register-heading">{singInHeading}</h2>
                <div className="my-2">
                  <button className="btn agent-login-register-tab active-agent-login-register-tab">
                    Sign In
                  </button>
                  <button
                    className="btn agent-login-register-tab ms-3"
                    onClick={handleChangeTab}
                  >
                    Register
                  </button>
                </div>
                <form className="agent-register-form">
                  <input
                    type="email"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Email"
                    onChange={(e) => setEmailLogin(e.target.value)}
                    value={emailLogin}
                  />

                  <input
                    type="password"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    onChange={(e) => setPasswordLogin(e.target.value)}
                    value={passwordLogin}
                  />
                  <p
                    onClick={handleForgot}
                    style={{ cursor: "pointer", lineHeight: "1px" }}
                    className="forgot-password-button mt-4"
                  >
                    Forgot Password?
                  </p>
                  <button
                    onClick={handleLogin}
                    className="btn agent-register-button"
                  >
                    Sign In
                  </button>
                  {/* <img
                  src="/img/agent-register-devider.svg"
                  className="img-fluid agent-register-devider"
                  alt=""
                />
                <button
                  type="button"
                  className="btn agent-register-google-button"
                >
                  <img src="/img/google.png" alt="" /> Continue with Google
                </button> */}
                </form>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="advertiser-signin-image-conatiner"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AdvertiserRegister;
